import Archive from './Pages/Archive';
import Blog from './Pages/Blog';
import {useEffect, useState} from 'react';
import Post from './Pages/Post';
import BlogMenu from './Pages/BlogMenu';

import posts from './posts.json';

let postNum = 0;

let newestFirst = [...posts];
newestFirst.sort((a,b) => {
  if(a.postID > b.postID) {
    return -1;
  } else {
    return 1;
  }
});


export default function App() {
  let changeCurPg = (pg) => {
    switch(pg) {
      case 'BlogMenu':
        setCurPg(<BlogMenu posts={newestFirst} chng={changeCurPg}/>);
        break;
      case 'Blog':
        setCurPg(<Blog posts={newestFirst} chng={changeCurPg}/>);
        break;
      case 'Archive':
        setCurPg(<Archive chng={changeCurPg}/>);
        break;
      case 'Post':
        setCurPg(<Post posts={posts} chng={changeCurPg} post={postNum}/>);
        break;
      default:
        break;
    }
  }

  let [curPg, setCurPg] = useState(<Archive chng={changeCurPg}/>);

  useEffect(() => {
    let params = window.location.search;

    console.log(params);

    if(params.includes(`post=`)) {
      let tmpStr = params.split('post=')[1];
      tmpStr = tmpStr.split('&')[0];
      postNum = parseInt(tmpStr);
      changeCurPg('Post');
    }else if(params.includes("doom=1")){
      changeCurPg('Blog');
    }else if(params.includes(`blog=1`)) {
      changeCurPg('BlogMenu');
    }


  }, []);

  return(
    <div className='app'>
        {
          curPg
        }
    </div>
  );
}